<lx-price-lists-portal-table-header title="Pathway program prices" [currency]="currency()"></lx-price-lists-portal-table-header>

<p-table [value]="dataSource()">
  <ng-template pTemplate="header">
    <tr [class]="'table__header--' + (company() | lowercase)">
      <th class="pathway-program-table__header__level table__header--uppercase" rowspan="2">
        {{ columnLabels().title }}
      </th>
      @for (level of columnLabels().levels; track level.priceKey) {
      <th class="pathway-program-table__header__level">
        {{ level.level }}
      </th>
      }
    </tr>
    <tr [class]="'table__header--' + (company() | lowercase)">
      @for (level of columnLabels().levels; track level.priceKey) {
      <th class="pathway-program-table__header__level">
        {{ level.duration }}
      </th>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-data>
    <tr>
      <td class="table__cell--product-name">{{ data.name }}</td>
      @for (level of columnLabels().levels; track level.priceKey) {
      <td class="table__cell--center">
        {{ data.prices[level.priceKey] | lxPrice : { defaultValue: '-' } }}
      </td>
      }
    </tr>
  </ng-template>
</p-table>
